module.exports = __webpack_public_path__ + "static/img/24.4a693a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/24.jpg
// module id = 9Nht
// module chunks = 16